export default __webpack_public_path__ + "static/media/banner4.91a4762a.jpg";